<template>
  <div>
    <v-container v-if='isLoading'>
      <wc-loading line message='Getting estimate details'></wc-loading>
    </v-container>
    <wc-page-title v-if='estimate' :title='estimate.name' :subtitle='subtitle'>
      <template v-slot:appendSubtitle>
        <v-tooltip v-if='estimate.is_comm' top open-delay='500'>
          <template v-slot:activator='{ on }'>
            <v-icon v-if='estimate.is_comm' v-on='on'
              :class="'ml-2 ' + ($vuetify.breakpoint.mdAndUp ? 'mt-n4' : 'mt-n2')" :large='$vuetify.breakpoint.mdAndUp'
              color='primary'>
              mdi-domain
            </v-icon>
          </template>
          Commercial Estimate
        </v-tooltip>
        <v-tooltip v-if='!estimate.is_comm' top open-delay='500'>
          <template v-slot:activator='{ on }'>
            <v-icon v-if='!estimate.is_comm' v-on='on'
              :class="'ml-2 ' + ($vuetify.breakpoint.mdAndUp ? 'mt-n4' : 'mt-n2')" :large='$vuetify.breakpoint.mdAndUp'
              color='info'>
              mdi-home-outline
            </v-icon>
          </template>
          Residential Estimate
        </v-tooltip>
      </template>
      <template v-slot:rightSide>
        <wc-estimate-type v-if='estimate && estimate.division_obj.division === "Irrigation"' left
          :estimate='estimate'></wc-estimate-type>
        <wc-estimate-status v-if='estimate' left :estimate='estimate' showTooltip></wc-estimate-status>
        <wc-burger-menu>
          <v-list-item @click='showWODialog = true'>
            <v-list-item-icon>
              <v-icon :color='$store.state.icons.modules.workorders.color'>
                {{ $store.state.icons.modules.workorders.icon }}
              </v-icon>
            </v-list-item-icon>
            <v-list-item-title>Create Work Order</v-list-item-title>
          </v-list-item>

          <v-list-item @click='showSendDialog = true'>
            <v-list-item-icon>
              <v-icon color='info'>mdi-email</v-icon>
            </v-list-item-icon>
            <v-list-item-title>Email Estimate</v-list-item-title>
          </v-list-item>

          <v-list-item @click='downloadEstimate'>
            <v-list-item-icon>
              <v-icon color='error'>mdi-file-pdf-box-outline</v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title>Download PDF</v-list-item-title>
            </v-list-item-content>
          </v-list-item>

          <v-list-item @click='previewEstimate'>
            <v-list-item-icon>
              <v-icon color='purple'>mdi-file-find</v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title>Preview Estimate</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
          <v-list-item @click='isReadyToSell' :disabled='estimate.is_sold'>
            <v-list-item-icon>
              <v-icon color='error'>mdi-license</v-icon>
            </v-list-item-icon>
            <v-list-item-title v-if='!estimate.is_ready_to_sell'>Ready to sell</v-list-item-title>
            <v-list-item-title v-else>NOT Ready to sell</v-list-item-title>
          </v-list-item>
          <v-list-item @click='openSellEstimate' :disabled='!estimate.is_ready_to_sell || estimate.is_sold'>
            <v-list-item-icon>
              <v-icon color='success'>mdi-license</v-icon>
            </v-list-item-icon>
            <v-list-item-title>Sell</v-list-item-title>
          </v-list-item>
          <v-divider></v-divider>
          <v-list-item @click='toggleArchive' :disabled='estimate.is_sold'>
            <v-list-item-icon>
              <v-icon color='red'>mdi-archive</v-icon>
            </v-list-item-icon>
            <v-list-item-title>
              <span v-if='estimate.archived'>UN-Archive</span>
              <span v-else>Archive</span>
            </v-list-item-title>
          </v-list-item>
        </wc-burger-menu>
      </template>
    </wc-page-title>
    <v-container v-if='estimate && estimate.archived'>
      <v-alert border='bottom' type='error'>Estimate is archived</v-alert>
    </v-container>

    <!-- Create Work order -->
    <wc-dialog title='Create estimate work order?' :icon='$store.state.icons.modules.workorders.icon'
      :showDialog='showWODialog' width='450' saveText="Create" :loading='isCreatingWO' :loadingButtons='isCreatingWO'
      @save='createWO' @cancel='showWODialog = false'>
      <br><br>
      <p class='primary--text font-weight-bold'>For Non-billable work only!!</p>
      <p>This work order should be used for <span class='font-weight-bold'>infomation gathering</span>, and should not
        be
        used for any actual service-type work.</p>
      <p>(Billable work MUST be connected to a project. If you wish to create a service work order, the estimate should
        be
        sold first.)</p>
      <br><br>
      <i>Once created, the estimate work order will be placed into the unscheduled section of the Service Schedule and
        you
        will be taken directly to the work order page so you can edit any addtional details.</i>
    </wc-dialog>

    <!--  CANNOT SELL DIALOG -->
    <wc-dialog title='Cannot Sell' icon='mdi-cancel' iconColor='error' :showDialog='cannotSellDialog' hideCancel
      saveText='OK' @save='cannotSellDialog = false' width='300'>
      <br>
      You cannot sell this estimate. The following information is missing:<br>
      <br>
      <p v-for='(m, index) in missingForSell' :key='index'>
        <v-icon v-if='m.status' color='success'>mdi-check</v-icon>
        <v-icon v-else color='error'>mdi-close</v-icon>
        {{ m.value }}
      </p>
      <br>
      <br>
      Please fix the above before selling.
    </wc-dialog>


    <!-- Confirm Sell -->
    <wc-dialog title='Confirm Sell' icon='mdi-help-circle-outline' :showDialog='confirmSellDialog' width='400'
      :loading='isSelling' :loadingButtons='isSelling' saveText="Yes, I'm sure" @save='sellEstimate'
      @cancel='confirmSellDialog = false'>
      <br>
      Selling an estimate will:<br>
      <br>
      <ul v-if='estimate'>
        <li>Mark estimate as "sold"</li>
        <li v-if="estimate.division_obj.division_type === 'S'">Send a confirmation to the listed "Owner"</li>
        <li v-if="estimate.division_obj.division_type === 'S'">Create a new Snow project</li>
        <li v-if="estimate.division_obj.division_type === 'S'">Generate invoice(s) for the season</li>
        <li v-if="estimate.division_obj.division_type === 'I'">Create a new Irrigation project</li>
        <li v-if="estimate.division_obj.division_type === 'I'">Generate an install invoice</li>
        <li v-if="estimate.division_obj.division_type === 'L'">Create a new Lawn project</li>
        <li v-if="estimate.division_obj.division_type === 'L'">Generate all necessary invoices</li>
        <li v-if="estimate.division_obj.division_type === 'L'">Generate all necessary work orders</li>
      </ul>
      <br>
      Are you sure you want to sell this estimate?<br>
      <br>
      <v-alert dense type='warning' border='bottom'>This cannot be undone</v-alert>
    </wc-dialog>

    <!-- Ready To Sell Warning Checklist -->
    <wc-dialog title='Confirm Readiness' icon='mdi-check-all' :showDialog='showConfirmReadiness' width='450'
      saveText="Ready" @save='toggleReadyToSell' @cancel='showConfirmReadiness = false'>
      Please make sure the following items are complete for this estimate before marking it 'Ready to Sell':<br>
      <br>
      <ul>
        <li v-for="(l, index) in readinessText" :key='index'>{{ l }}</li>
      </ul>
    </wc-dialog>


    <!-- Confirm Email -->
    <wc-dialog title='Email Quote Test' icon='mdi-email' :showDialog='showSendDialog' width='700' :loading='emailing'
      saveText="Send" :disableButtons='disableEmailSendButtons' @save='emailEstimate' @cancel='showSendDialog = false'>
      <v-form v-model='isFormValid'>
        <v-select dense class='mb-6' :rules='[rules.required]' label='Send quote to:' :items='emailToOptions'
          @change='updateEmailTo' v-model='email_to_selection'></v-select>
        <v-text-field dense class='mb-6' :rules='[rules.required]' label='Sending to email address:'
          v-model='email_data.to' hint='If empty, the contact may not have an email address set'
          persistent-hint></v-text-field>
        <v-select dense :rules='[rules.required]' label='From:' :items='emailFromOptions'
          v-model='email_data.from'></v-select>
        <v-select dense :rules='[rules.required]' label='Notice Optional' :items='notices' item-text='name'
          return-object @change='selectNotice()' v-model='notice_selected'></v-select>
        <v-checkbox label="Show Price" v-model='show_price'></v-checkbox>
        <v-checkbox :label='bcc_label' v-model='bcc_sender'></v-checkbox>
        <strong>Message:</strong>
        <vue-editor v-model='email_data.message' :editor-toolbar='customToolbar'></vue-editor>
      </v-form>
      <br>
      <v-alert v-if="estimate && !estimate.owner && estimate.estimate_type !== 'SE'" small border='right'
        type='error'>An
        owner must be selected!</v-alert>
    </wc-dialog>

    <!-- Confirm Preview -->
    <wc-dialog title='Preview Quote' icon='mdi-email' :showDialog='confirmPreview' saveText="Send Preview"
      @save='sendPreview' @cancel='showSendDialog = false'>
      <br>
      This will send the quote to your email address so you
      can see what the delivered quote will look like. This does not
      change any details of the quote, it simply sends the quote to you to have a look.<br>
      <br>The preview will be sent to:<br><br>
      <strong>{{ $store.state.auth.profile.email }}</strong> <br>
      <br>Would you like to send the preview to your email?<br>
    </wc-dialog>
    <router-view ref='estRouter' v-if='readyToRender' :estimate='estimate' :project='project' :loading='isLoading'
      @update='updateEstimate' @updateEstimateWithoutApiCall='updateEstimateWithoutApiCall'></router-view>
    <deliverable-preview v-show='false' v-if='estimate' ref='deliverable' :estimate='estimate' :lines='lines'
      :options='options'></deliverable-preview>
  </div>
</template>

<script>
import trackerAPI from '@/api/tracker';
import noticesAPI from '@/api/notices';
import estimatesAPI from '@/modules/estimates/api/estimates';
import projectsAPI from '@/modules/projects/api/projects';
//import accountingAPI from '@/api/accounting';
import wosAPI from '@/modules/wos/api';
import WCEstimateStatus from '@/components/chips/WCEstimateStatus';
import WCEstimateType from '@/components/chips/WCEstimateType';
import formRules from '@/mixins/formRules';
import DeliverablePreview from './DeliverablePreview';
import moment from 'moment';
import endpoints from '@/api/endpoints';
import { VueEditor } from 'vue2-editor';
import _ from 'lodash';

export default {
  name: 'estimate-base',
  mixins: [formRules],
  data: () => ({
    isLoading: true,
    isSelling: false,
    isFormValid: false,
    isCreatingWO: false,
    newWO: {},
    notices: [],
    notice_was_selected: false,
    notice_selected: {},
    showWODialog: false,
    showSendDialog: false,
    showConfirmReadiness: false,
    confirmPreview: false,
    estimate: null,
    hasInvoiceTemplates: false,
    hasOwner: false,
    hasBillTo: false,
    hasSiteAddress: false,
    hasStartDate: false,
    hasEndDate: false,
    hasDrivewayRating: false,
    cannotSellDialog: false,
    confirmSellDialog: false,
    emailing: false,
    email_data: {
      id: '',
      message: '<p>Hello:</p><p>Thank you for reaching out for a quote. If you have any questions, please feel free to contact us.</p><p>Capital Irrigation</p>',
      to: '',
      to_id: '',
      bcc: '',
      from: ''
    },
    show_price: true,
    bcc_sender: true,
    email_to_selection: '',
    customToolbar: [
      ['bold', 'italic', 'underline'],
      [{ list: 'ordered' }, { list: 'bullet' }]
    ],
    lines: [],
    options: [],
    missingForSell: [],
    // Project required for service estimates on existing systems.
    project: null
  }),
  computed: {
    readyToRender() {
      if (this.estimate && this.estimate_type === 'SE') {
        return (this.estimate && this.project)
      }
      return !!this.estimate
    },
    bcc_label() {
      if (this.bcc_sender) {
        return 'BCC: ' + this.email_data.from
      }
      return 'BCC:'
    },
    emailFromOptions() {
      let e = this.$store.state.auth.profile.email
      // This ensures that the user can only select their own email if it is a Capital email account.
      if (/@capitalirrigation.com\s*$/.test(e)) {
        return [
          { value: this.$store.state.auth.profile.email, text: this.$store.state.auth.profile.first_name + ' ' + this.$store.state.auth.profile.last_name + ' -- ' + this.$store.state.auth.profile.email },
          { value: 'customerservice@capitalirrigation.com', text: 'Capital Irrigation -- customerservice@capitalirrigation.com' }
        ]
      }
      return [
        { value: 'customerservice@capitalirrigation.com', text: 'Capital Irrigation -- customerservice@capitalirrigation.com' }
      ]
    },
    readinessText() {
      if (this.estimate) {
        if (this.estimate.estimate_type === 'NI') {
          return [
            "A sketch has been attached",
            "First Call booking information added",
            "Production Schedule notes added (how many squares, what color, etc)",
            "Scheduling considerations for the mechanical work order are included"
          ]
        } else {
          return [
            "A sketch has been attached",
            "Completed all fields"
          ]
        }
      }
      return []
    },
    emailToOptions() {
      let options = []
      if (this.estimate) {
        if (this.estimate.estimate_type === 'SE') {
          if (this.project) {
            options.push({ value: 'owner', text: this.project.owner ? 'Owner' : 'Owner (not set)', disabled: this.project.owner ? false : true })
            options.push({ value: 'bill_to', text: this.project.bill_to ? 'Billing contact' : 'Billing contact (not set)', disabled: this.project.bill_to ? false : true })
            options.push({ value: 'sales_contact', text: this.project.sales_contact ? 'Sales contact' : 'Sales contact (not set)', disabled: this.project.sales_contact ? false : true })
            options.push({ value: 'notices_contact', text: this.project.notices_contact ? 'Notices contact' : 'Notices contact (not set)', disabled: this.project.notices_contact ? false : true })
            options.push({ value: 'install_contact', text: this.project.install_contact ? 'Install contact' : 'Install contact (not set)', disabled: this.project.install_contact ? false : true })
            options.push({ value: 'site_contact', text: this.project.site_contact ? 'Service contact' : 'Service contact (not set)', disabled: this.project.site_contact ? false : true })
            options.push({ value: 'secondary_site_contact', text: this.project.secondary_site_contact ? 'Secondary Service contact' : 'Secondary Secondary Service contact (not set)', disabled: this.project.secondary_site_contact ? false : true })
          } else {
            options.push({ value: 'owner', text: 'No project?', disabled: true })
          }
        } else {
          options.push({ value: 'owner', text: this.estimate.owner ? 'Owner' : 'Owner (not set)', disabled: this.estimate.owner ? false : true })
          options.push({ value: 'bill_to', text: this.estimate.bill_to ? 'Billing contact' : 'Billing contact (not set)', disabled: this.estimate.bill_to ? false : true })
          options.push({ value: 'sales_contact', text: this.estimate.sales_contact ? 'Sales contact' : 'Sales contact (not set)', disabled: this.estimate.sales_contact ? false : true })
          options.push({ value: 'notices_contact', text: this.estimate.notices_contact ? 'Notices contact' : 'Notices contact (not set)', disabled: this.estimate.notices_contact ? false : true })
          options.push({ value: 'install_contact', text: this.estimate.install_contact ? 'Install contact' : 'Install contact (not set)', disabled: this.estimate.install_contact ? false : true })
          options.push({ value: 'site_contact', text: this.estimate.site_contact ? 'Service contact' : 'Service contact (not set)', disabled: this.estimate.site_contact ? false : true })
          options.push({ value: 'secondary_site_contact', text: this.estimate.secondary_site_contact ? 'Secondary Service contact' : 'Secondary Secondary Service contact (not set)', disabled: this.estimate.secondary_site_contact ? false : true })
        }
      }
      return options
    },
    estimateMenu() {
      let menu = []
      menu.push({
        title: this.$store.state.icons.routes.overview.title,
        icon: this.$store.state.icons.routes.overview.icon,
        route: { name: this.estimate.division_obj.division + 'Estimate', params: { id: this.$route.params.id } }
        // seems slightly cleaner than using projectServices.getProjectEstimateRoute, (just requires naming conventions to be consistent)
      })
      switch (this.estimate.division_obj.division) {
        // these names are set on api/global_options and cannot be changed by the user
        case 'Snow':
          // menu.push({
          //   title: 'Invoice Setup',
          //   icon: this.$store.state.icons.dataBox.invoices.icon,
          //   route: { name: 'InvoiceTemplates', params: { id: this.$route.params.id } }  // snow project menu item only.
          // },
          // {
          //   title: 'Confirmation Letter',
          //   icon: 'mdi-file-document-outline',
          //   route: { name: 'ConfirmationLetter', params: { id: this.$route.params.id } }  // snow project menu item only.
          // })
          break
        case 'Irrigation':
          if (this.estimate) {
            if (this.estimate.estimate_type === 'NI') {
              menu.push({
                title: 'Printout',
                icon: 'mdi-file-document-outline',
                route: { name: 'IrrigationEstimatePrintout', params: { id: this.$route.params.id } }
              })
            }
          }
          break
        case 'Lawn':
          menu.push({
            title: 'Invoice Setup',
            icon: this.$store.state.icons.dataBox.invoices.icon,
            route: { name: 'InvoiceTemplates', params: { id: this.$route.params.id } }  // snow project menu item only.
          })
          break
        case 'Construction':
          // Menu items specific to construction estimates here (none yet)
          break
        case 'Software':
          // Menu items specific to software estimates here (none yet)
          break
      }
      // below are menu items still common to all divisions
      menu.push({
        title: this.$store.state.icons.routes.actionTracker.title,
        icon: this.$store.state.icons.routes.actionTracker.icon,
        route: { name: 'EstimateActionTracker', params: { id: this.$route.params.id } }
      })
      return menu
    },
    disableEmailSendButtons() {
      // For service estimates on an existing system, we don't care if the estimate doesn't have an owner, because we're using the project owner.
      // But for all other emails, we need an estimate.owner
      if (this.estimate) {
        if (this.estimate.estimate_type == 'SE') {
          // If the form is NOT valid, then yes -- disable the send button
          return !this.isFormValid
        }
        return !this.isFormValid || !this.estimate.owner
      }
      // Default of returning true -- yes, disable sending an email
      return true
    },
    subtitle() {
      return this.estimate ? this.estimate.division_obj.division : ''
    },
  },
  async mounted() {
    this.getEstimate();
    this.notices = await noticesAPI.getNotices();
    this.setEmailMessage();
  },
  methods: {
    getProposalType() {
      if (this.estimate.division_obj.division_type === "I") {
        return "irrigation proposal";
      }
      else if (this.estimate.division_obj.division_type === "L") {
        return "lawn proposal";
      }
      else if (this.estimate.division_obj.division_type === "S") {
        return "snow proposal";
      }
      else {
        return "";
      }
    },
    setEmailMessage() {
      this.email_data.message = `<p>Hi ${this.estimate && this.estimate.owner_obj && this.estimate.owner_obj.name ?
        this.estimate.owner_obj.name : ""
        },</p><p>I have the ${this.getProposalType()} attached below. Let me know if you have any questions, or if you would like to book our services.</p><p>Thanks,</p><p>${this.estimate && this.estimate.estimator_obj ?
          `${this.estimate.estimator_obj.first_name} ${this.estimate.estimator_obj.last_name}` :
          ""}</p>`;
    },
    selectNotice() {
      this.notice_was_selected = true;
    },
    updateEmailTo() {
      // Used when emailing the estimate. This sets to whom the estimate should be sent
      switch (this.email_to_selection) {
        case 'owner':
          this.email_data.to = this.project ? this.project.owner_obj.email : this.estimate.owner_obj.email
          this.email_data.to_id = this.project ? this.project.owner : this.estimate.owner
          break;
        case 'bill_to':
          this.email_data.to = this.project ? this.project.bill_to_obj.email : this.estimate.bill_to_obj.email
          this.email_data.to_id = this.project ? this.project.bill_to : this.estimate.bill_to
          break;
        case 'sales_contact':
          this.email_data.to = this.project ? this.project.sales_contact_obj.email : this.estimate.sales_contact_obj.email
          this.email_data.to_id = this.project ? this.project.sales_contact : this.estimate.sales_contact
          break;
        case 'notices_contact':
          this.email_data.to = this.project ? this.project.notices_contact_obj.email : this.estimate.notices_contact_obj.email
          this.email_data.to_id = this.project ? this.project.notices_contact : this.estimate.notices_contact
          break;
        case 'install_contact':
          this.email_data.to = this.project ? this.project.install_contact_obj.email : this.estimate.install_contact_obj.email
          this.email_data.to_id = this.project ? this.project.install_contact : this.estimate.install_contact
          break;
        case 'site_contact':
          this.email_data.to = this.project ? this.project.site_contact_obj.email : this.estimate.site_contact_obj.email
          this.email_data.to_id = this.project ? this.project.site_contact : this.estimate.site_contact
          break;
        case 'secondary_site_contact':
          this.email_data.to = this.project ? this.project.secondary_site_contact_obj.email : this.estimate.secondary_site_contact_obj.email
          this.email_data.to_id = this.project ? this.project.secondary_site_contact : this.estimate.secondary_site_contact
          break;
        default:
          break;
      }
    },
    async getEstimate() {
      this.isLoading = true
      this.estimate = await estimatesAPI.getEstimates(this.$route.params.id)
      this.$store.dispatch('loadSubnavTitle', this.estimate.name)
      this.$store.dispatch('loadSubnav', this.estimateMenu)
      if (this.estimate.estimate_type == 'SE' && this.estimate.project) {
        await this.getProject()
      }
      this.isLoading = false
    },
    async getProject() {
      // This should only be called if the estimate is a service estimate for an existing Project
      // Some project related components rely on contact objects to be present, which is why project_obj is not quite sufficient.
      this.project = await projectsAPI.getProject(this.estimate.project)
    },
    updateEstimateWithoutApiCall(alreadyUpdatedEstimate) {
      this.estimate = alreadyUpdatedEstimate
    },
    async updateEstimate(estimate = null) {
      if (!estimate) {
        this.estimate = await estimatesAPI.getEstimates(this.$route.params.id)
      } else {
        this.estimate = await estimatesAPI.updateEstimate(estimate)
      }
    },
    async openSellEstimate() {
      if (await this.canSell()) {
        this.confirmSellDialog = true
      } else {
        this.cannotSellDialog = true
      }
    },
    async sellEstimate() {
      this.isSelling = true;
      const project = await estimatesAPI.sellEstimate(this.estimate.id);
      this.$router.push({ name: project.division_obj.division + 'Overview', params: { id: project.id } });
      this.confirmSellDialog = false;
      this.isSelling = false;
    },
    async canSell() {
      // Snow Checks
      if (this.estimate.division_obj.division_type === 'S') {
        this.hasDrivewayRating = this.estimate.estimate_detail.driveway_rating ? true : false
        this.hasOwner = this.estimate.owner ? true : false
        this.hasBillTo = this.estimate.bill_to ? true : false
        this.hasSiteAddress = this.estimate.site_address ? true : false
        this.hasStartDate = this.estimate.start_date ? true : false
        this.hasEndDate = this.estimate.end_date ? true : false

        this.missingForSell = []
        this.missingForSell.push({ value: 'Driveway Rating', status: this.hasDrivewayRating })
        this.missingForSell.push({ value: 'Owner', status: this.hasOwner })
        this.missingForSell.push({ value: 'Billing Contact', status: this.hasBillTo })
        this.missingForSell.push({ value: 'Site Address', status: this.hasSiteAddress })
        this.missingForSell.push({ value: 'Start Date', status: this.hasStartDate })
        this.missingForSell.push({ value: 'End Date', status: this.hasEndDate })

        return this.hasOwner && this.hasSiteAddress && this.hasStartDate && this.hasEndDate && this.hasDrivewayRating
      }

      // Irrigation Checks before selling
      if (this.estimate.division_obj.division_type === 'I') {
        if (this.estimate.estimate_type !== 'SE') {
          this.missingForSell = []
          this.missingForSell.push({ value: 'Owner', status: this.estimate.owner !== null })
          this.missingForSell.push({ value: 'Billing contact', status: this.estimate.bill_to !== null })
          this.missingForSell.push({ value: 'Install contact', status: this.estimate.install_contact !== null })
          this.missingForSell.push({ value: 'Primary service contact', status: this.estimate.site_contact !== null })
          this.missingForSell.push({ value: 'Secondary service contact', status: this.estimate.secondary_site_contact !== null })
          this.missingForSell.push({ value: 'Site address', status: this.estimate.site_address ? true : false })
          this.missingForSell.push({ value: 'Sketch', status: true })
          // this.missingForSell.push({ value: 'Route Position', status: this.estimate.route_group !== "" && this.estimate.route_number !== null })
          this.missingForSell.push({ value: 'Quote', status: this.estimate.amount ? true : false })
          return this.estimate.owner
            && this.estimate.bill_to
            && this.estimate.install_contact
            && this.estimate.site_contact
            && this.estimate.secondary_site_contact
            && this.estimate.site_address
            && this.estimate.amount
            && true
          // && this.estimate.route_group
          // && this.estimate.route_number
        } else {
          this.missingForSell = []
          this.missingForSell.push({ value: 'Quote', status: this.estimate.amount ? true : false })
          return this.estimate.amount
        }
      }

      // Lawn checks
      if (this.estimate.division_obj.division_type === 'L') {
        this.missingForSell = []
        this.missingForSell.push({ value: 'Owner', status: this.estimate.owner !== null })
        this.missingForSell.push({ value: 'Billing contact', status: this.estimate.bill_to !== null })
        this.missingForSell.push({ value: 'Site address', status: this.estimate.site_address ? true : false })
        this.missingForSell.push({ value: 'Lot category', status: this.estimate.estimate_detail.rating ? true : false })
        this.missingForSell.push({ value: 'Invoice Setup', status: true })

        return this.estimate.owner
          && this.estimate.bill_to
          && this.estimate.site_address
          && this.estimate.estimate_detail.rating
          && true;
      }
    },
    isReadyToSell() {
      if (this.estimate.division_obj.division_type === 'I') {
        this.showConfirmReadiness = true
      } else {
        this.toggleReadyToSell()
      }
    },
    toggleReadyToSell() {
      this.estimate.is_ready_to_sell = !this.estimate.is_ready_to_sell;

      let description = '';
      description = this.estimate.is_ready_to_sell ? 'Estimate set to READY to sell' : 'Estimate set to NOT ready to sell';

      const tracker = {
        'tracker_data': {
          'description': description,
          'taken_by': this.$store.state.auth.profile.id,
          'action_date': moment().format('YYYY-MM-DD').toString(),
        },
        'estimate': this.estimate.id
      }
      trackerAPI.createEstimateTracker(tracker);
      this.updateEstimate(this.estimate);
      this.showConfirmReadiness = false;
    },
    toggleArchive() {
      this.estimate.archived = !this.estimate.archived

      let description = '';
      description = this.estimate.archived ? 'Estimate archived' : 'Estimate un-archived';

      const tracker = {
        'tracker_data': {
          'description': description,
          'taken_by': this.$store.state.auth.profile.id,
          'action_date': moment().format('YYYY-MM-DD').toString(),
        },
        'estimate': this.estimate.id
      }
      trackerAPI.createEstimateTracker(tracker);
      this.updateEstimate(this.estimate)
    },
    sendPreview() {
      estimatesAPI.previewEstimate(this.estimate.id)
      this.confirmPreview = false
    },
    async emailEstimate() {
      this.emailing = true;
      this.email_data.id = this.estimate.id;
      this.email_data.bcc = this.bcc_sender ? this.email_data.from : '';


      if (this.notice_was_selected) {
        this.estimate = await noticesAPI.emailNotice(this.notice_selected.id, null, this.estimate.id, this.email_data.from, this.email_data.to, this.email_data.bcc, this.email_data.message);
      }
      else {
        this.estimate = await estimatesAPI.emailEstimate(this.estimate.id, this.email_data, this.show_price);
      }

      const tracker = {
        'tracker_data': {
          'description': '',
          'action': 'Emailed Estimate',
          'taken_by': this.$store.state.auth.profile.id,
          'action_date': moment().format('YYYY-MM-DD').toString(),
        },
        'estimate': this.estimate.id
      }
      trackerAPI.createEstimateTracker(tracker);
      this.notice_was_selected = false;
      this.showSendDialog = false;
      this.emailing = false;
      this.email_data = {
        id: '',
        message: "",
        to: '',
        to_id: '',
        bcc: '',
        from: ''
      }
      this.setEmailMessage();
    },
    downloadEstimate() {
      const link = document.createElement('a')
      const previewURL = this.$axios.defaults.baseURL + endpoints.downloadEstimate + this.estimate.id
      link.target = '_blank'
      link.href = previewURL
      link.click()
    },
    previewEstimate() {
      const link = document.createElement('a')
      const previewURL = this.$axios.defaults.baseURL + endpoints.previewEstimate + this.estimate.id
      link.target = '_blank'
      link.href = previewURL
      link.click()
    },
    async createWO() {
      this.isCreatingWO = true
      this.newWO.estimate = this.estimate.id
      this.newWO.created_by = this.$store.state.auth.profile.id
      this.newWO.problem_description = 'Gather Estimate Details'
      this.newWO.wo_type = _.find(this.$store.state.misc.woTypes, w => w.category === 'ES').id
      let tmp = await wosAPI.createWO(this.newWO)
      this.isCreatingWO = false
      this.showWODialog = false
      this.$router.push({ name: 'WOOverview', params: { id: tmp.id } })
    }
  },
  components: {
    'wc-estimate-status': WCEstimateStatus,
    'wc-estimate-type': WCEstimateType,
    'deliverable-preview': DeliverablePreview,
    'vue-editor': VueEditor
  }
}
</script>
